import { useState } from "react";
import { updateAppointment } from "../../api/appointmentService";

export const useUpdateAppointment = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const updatedRecord = await updateAppointment(id, data);
      setUpdating(false);
      if (successCallback) successCallback(updatedRecord);
      return updatedRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update appointment:", error);
      throw error;
    }
  };

  return { update, updating };
};